import React, { Component, PropTypes } from 'react'
import { browserHistory } from 'react-router'
import Dialog from '../dialog'
import { Button } from '../ui'

function redirectToSignIn() {
    browserHistory.push('/sign-in')
}

export default class Activate extends Component {
    static displayName = 'Activate'

    static propTypes = {
        account: PropTypes.shape({
            activation: PropTypes.string,
        }).isRequired,
        actions: PropTypes.shape({
            activate: PropTypes.func.isRequired,
        }).isRequired,
        appState: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
        }).isRequired,
        params: PropTypes.shape({
            token: PropTypes.string.isRequired,
            uuid: PropTypes.string.isRequired,
        }).isRequired,
    }

    componentWillMount() {
        const uuid = this.props.params.uuid
        const token = this.props.params.token

        this.props.actions.activate(uuid, token)
    }

    render() {
        const activation = this.props.account.activation

        const header = (
            <div className="logo">
                <img alt="" src="/img/hayden-logo.png" width="200" />
            </div>
        )

        let content = null

        if (this.props.appState.loading) {
            content = (
                <div className="align-center">
                    <span className="loader loader--large loader--red" />
                </div>
            )
        } else if (activation === 'USER_INVALID') {
            content = (
                <div className="align-center">
                    <p>The activate link is invalid.</p>
                </div>
            )
        } else if (activation === 'TOKEN_INVALID') {
            content = (
                <div className="align-center">
                    <p>The token is invalid.</p>
                </div>
            )
        } else if (activation === 'ACTIVATED') {
            content = (
                <div className="align-center">
                    <p>Thank you for activating your new account with us.</p>

                    <p>Please click the button below to complete your profile.</p>

                    <Button
                        fullWidth
                        onClick={ redirectToSignIn }
                        status="primary"
                    >
                        Get started
                    </Button>
                </div>
            )
        }

        return (
            <Dialog allowClose={ false } background={ false } header={ header } open size="small">
                <h4 className="align-center">Account Successfully Verified</h4>
                { content }
            </Dialog>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/account/activate.js